"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBillingAddress = void 0;
var _auth = require("@ori/auth");
var _checkoutDelivery = require("@ori/checkout-delivery");
var _checkoutUtils = require("@ori/checkout-utils");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _shoppingContext = require("@ori/shopping-context");
var _contexts = require("../../contexts");
var _logger = require("../../logger");
function handleCallbackError({
  httpStatus,
  response
}) {
  (0, _checkoutUtils.showErrorNotification)();
  const description = `HTTP status code: ${httpStatus === undefined ? 'unknown' : httpStatus.toString()}`;
  const error = new Error('Error while working with address data.');
  const childLogger = _logger.mainLogger.createChild('handleCallbackError');
  childLogger.error(error, {
    description
  });
}
const useBillingAddress = () => {
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    globalApiUrl,
    identityUrl,
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['globalApi', 'identity', 'staticApi']);
  const {
    formattedToken,
    token
  } = (0, _auth.useToken)();
  const {
    mutateCustomerCheckoutPrerequisites
  } = (0, _contexts.useNavigationContext)();
  const {
    isLoaded,
    isLoading,
    shoppingContext: {
      customerId = _auth.NOT_LOGGED_IN_USER_ID,
      isDeliveryChannelSelected = false,
      shoppingBagOwnerName = ''
    } = {}
  } = (0, _shoppingContext.useShoppingContext)();
  const {
    data: {
      customerAddressesCollection = []
    } = {},
    mutate: mutateCustomerAddresses,
    isValidating: areCustomerAddressesLoading
  } = (0, _globalApiClientReact.useGetCustomerAddresses)(customerId, {}, undefined, {
    swr: {
      enabled: isDeliveryChannelSelected,
      ..._checkoutUtils.errorHandlingSwrOptions
    }
  });
  const handleAddressFormCallbackData = data => {
    (0, _logger.logDebug)('handleAddressFormCallbackData() called.\n\tCurrent form data:', data);
    void mutateCustomerAddresses();
    void mutateCustomerCheckoutPrerequisites();
  };
  const handleBillingAddressRefresh = () => {
    (0, _logger.logDebug)('handleBillingAddressRefresh() called.');
    void mutateCustomerAddresses();
    void mutateCustomerCheckoutPrerequisites();
  };
  const billingAddress = customerAddressesCollection.find(customerAddress => customerAddress.isBilling);
  const isShoppingContextLoading = isLoading && !isLoaded;
  const isQueryLoading = isShoppingContextLoading || areCustomerAddressesLoading;

  // create address-form properties
  const addressFormProps = {
    appConfiguration: {
      globalApiUrl,
      identityUrl,
      processContext: _checkoutDelivery.processContext,
      staticApiUrl,
      tenant,
      currentLanguage: language,
      formattedToken,
      token
    },
    customerId,
    configForm: {
      hideActionButtons: false,
      isDialog: false
    },
    handleCallbackData: handleAddressFormCallbackData,
    handleCallbackError
  };
  return {
    billingAddressContentProps: {
      addressFormProps,
      billingAddress,
      shoppingBagOwnerName
    },
    handleBillingAddressRefresh,
    isDeliveryChannelSelected,
    isQueryLoading
  };
};
exports.useBillingAddress = useBillingAddress;